module.exports = __webpack_public_path__ + "static/img/whole_banner1.d1d17dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/solution/whole_banner1.png
// module id = fK4T
// module chunks = 1